import Typography from '@material-ui/core/Typography';
import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import {
  Route, Switch,
} from 'react-router-dom';
import FacilityStatistics from 'screens/facilityRatingStatistics/facilityStatistics';
import WifiPackagesScreen from 'screens/wifiPackagesManagementScreen/wifiPackages';
import AddEditWifiPackage from 'screens/addEditWifiPackagesScreen/addEditWifiPackages';
import AddNotification from 'screens/sendNotificationScreen';
import CustomScreens from 'screens/customScreensScreen';
import AddEditCustomScreen from 'screens/addEditCustomScreen';
import SurveysScreen from 'screens/surveyManagementScreen/surveys';
import AddEditSurveyScreen from 'screens/surveyManagementScreen/addEditSurvey'
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  changeDefaultLanguage, languageCodes,
} from '../../constants/languages';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  AuthStore,
} from '../../mobx-store/stores/authStore';
import Academies from '../../screens/academiesManagementScreen/academies';
import AddEditAcademy from '../../screens/addEditAcademyScreen/addEditAcademy';
import AddEditAds from '../../screens/addEditAdsScreen/addEditAds';
import AddEditArticle from '../../screens/addEditArticleScreen/addEditArticle';
import AddEditBranch from '../../screens/addEditBranchScreen/addEditBranch';
import AddEditCalenderSeprator from '../../screens/addEditCalenderSepratorScreen/addEditCalenderSeprator';
import AddEditDeglawyContent from '../../screens/addEditDeglawyContent/addEditDeglawyContent';
import AddEditDeglawyFeatured from '../../screens/addEditDeglawyFeaturedScreen/addEditDeglawyFeatured';
import AddEditDeglawyPortalContent from '../../screens/addEditDeglawyPortalContentScreen/addEditDeglawyPortalContent';
import AddEditDeglawyTrophy from '../../screens/addEditDeglawyTrophyScreen/addEditDeglawyTrophy';
import AddEditEventCategory from '../../screens/addEditEventCategoryScreen/addEditEventCategory';
import AddEditEvent from '../../screens/addEditEventsScreen/addEditEvents';
import AddEditFacilityCategory from '../../screens/addEditFacilitiesCategoriesScreen/addEditFacilityCategory';
import AddEditFacility from '../../screens/addEditFacilitysScreen/addEditFacility';
import AddEditFeaturedArticles from '../../screens/addEditFeaturedArticles/addEditFeaturedArticles';
import addEditFeaturedOffer from '../../screens/addEditFeaturedOffer/addEditFeaturedOffer';
import AddEditGalleryImage from '../../screens/addEditGalleryImageScreen/addEditGalleryImage';
import AddEditMenu from '../../screens/addEditMenuScreen/addEditMenu';
import AddEditNewsCategory from '../../screens/addEditNewsCategoriesScreen/addEditNewsCategory';
import AddEditRestaurantCategory from '../../screens/addEditRestaurantCategoryScreen/addEditRestaurantCategory';
import AddEditRestaurant from '../../screens/addEditRestaurantScreen/addEditRestaurant';
import addEditSettings from '../../screens/addEditSettingsScreen/addEditSettings';
import AddEditStaticText from '../../screens/addEditStaticTextScreen/addEditStaticText';
import BannerAds from '../../screens/bannerAdsManagementScreen/bannerAds';
import Branches from '../../screens/branchesManagementScreen/branches';
import CreateHomeCards from '../../screens/CreateHomeCards/CreateHomeCards';
import DeglawyContents from '../../screens/deglawyContentManagement/deglawyContentScreen';
import DeglawyFeaturedScreen from '../../screens/deglawyFeaturedManagementScreen/deglawyFeatured';
import DeglawyPortalContents from '../../screens/deglawyPortalContentManagmentScreen/deglawyPortalContentManagementScreen';
import DeglawyTrophyScreen from '../../screens/deglawyTrophyManagementScreen/deglawyTrophy';
import eventCategory from '../../screens/eventCategoryManagementScreen/eventCategory';
import event from '../../screens/eventsManagementScreen/events';
import FacilitiesCategories from '../../screens/FacilitiesCategoriesScreen/facilitiesCategories';
import Facilities from '../../screens/facilitiesMangementScreen/facilities';
import FeaturedArticlesManagement from '../../screens/featuredArticlesManagementScreen/featuredArticlesManagement';
import FeaturedOffer from '../../screens/featuredOfferManagement/featuredOffers';
import Gallery from '../../screens/galleryManagementScreen/gallery';
import Home from '../../screens/homeScreen';
import MenuManagement from '../../screens/menuManagementScreen/menuManagement';
import NewsCategories from '../../screens/newsCategoriesScreen/newsCategories';
import News from '../../screens/newsManagementScreen/news';
import Notifications from '../../screens/notificationsManagementScreen/notificationsManagement';
import RestaurantCategories from '../../screens/restaurantCategoriesManagementScreen/restaurantCategories';
import Restaurants from '../../screens/restaurantsManagementScreen/restaurants';
import calenderSeprator from '../../screens/SepratorManagementScreen/seprator';
import Settings from '../../screens/settingsScreen/settings';
import StaticTexts from '../../screens/staticTextManagement/staticTexts';
import Statistics from '../../screens/statisticsScreen/statistics';
import CustomerServiceWorkingHours from '../../screens/customerServiceWorkingHoursScreen/customerServiceWorkingHours';
import ChangePassword from '../../screens/usersManagementScreen/changePasswordScreen/changePassword';
import UsersManagement from '../../screens/usersManagementScreen/usersManagement';
import AuthenticationRoute from '../AuthenticationRoute/AuthenticationRoute';
import Directives from '../Directives/Directives';
import Header from '../Header';
import NavBar from '../NavBar';
import ScrollToTop from '../Scroller';
import Spinner from '../Spinner';
import styles from './layout.module.scss';
import FacilitiesArea from '../../screens/facilityAreasScreen';
import AddEditFacilityArea from '../../screens/addEditFacilityAreaScreen';
import AddEditAdminUsers from '../../screens/addEditAdminUsersScreen/addEditAdminUsers';
import {
  ROLES,
} from '../NavBar/NavigationItems/routes';
import TransactionsManagement from '../../screens/transactionsManagementScreen/transactionsManagement';
import GeneralAds from '../../screens/generalAdsScreen/generalAds';
import AddEditGeneralAd from '../../screens/addEditGeneralAdScreen/addEditGeneralAd';
import RatingFacilitiesReport from '../../screens/ratingFacilitiesReportManagement/reportsManagement';
import OffersScreen from '../../screens/offerManagementScreen/offers';
import addEditOffer from '../../screens/addEditOffersScreen/addEditOffer';
import FacilityForm from '../../screens/facilityFormsScreen';
import AddEditFacilityForm from '../../screens/addEditFacilityForm';
import FacilityResponseReports from '../../screens/facilityResponsesScreen';
import TransactionsDetails from '../../screens/transactionsDetailsScreen/transactionsDetails';
import Gates from '../../screens/branchesGatesScreen/branchesGates';
import AddEditGate from '../../screens/addEditGateScreen/addEditGate';
import RatingFacilitiesBranchesList from '../../screens/ratingFacilitiesBranchesList/ratingFacilitiesBranchesList';
import RatingFacilitiesAreasList from '../../screens/ratingFacilitiesAreasList/ratingFacilitiesAreasList';
import FacilitiesBranchStatistics from '../../screens/facilitiesBranchRatingStatistics/facilitiesBranchStatistics';
import FacilitiesAreaStatistics from '../../screens/facilitiesAreaRatingStatistics/facilitiesAreaStatistics';
import FacebookInfo from '../../screens/facebookInfoScreen';
import WheelPrizesScreen from 'screens/wheelOfFortuneScreens/prizesScreen';
import AddEditPrizeScreen from 'screens/wheelOfFortuneScreens/addEditPrize';
import WheelEventsScreen from 'screens/wheelOfFortuneScreens/eventsScreen';
import AddEditEventScreen from 'screens/wheelOfFortuneScreens/addEditEvent/addEditEvent';
import WheelEventWinnersScreen from 'screens/wheelOfFortuneScreens/eventWinnersScreen';
import WheelEventsGroupsScreen from 'screens/wheelOfFortuneScreens/eventsGroupsScreen';
import MobileUserRegistration from 'screens/mobileUserRegistration';
import RestaurantMenuBulkUpload from 'screens/restaurantsMenuBulkSeed';
import UserRenewalsScreen from 'screens/userRenewalsScreen';
import WifiPackagesUserSubscribeDetails from 'screens/wifiPackagesUserSubscribeDetails';
import UserDetails from 'screens/statisticsScreen/userDetails';
import ReleasesNotesTableScreen from '../../screens/releaseNotesScreen';
import AddEditReleaseNotesScreen from '../../screens/releaseNotesScreen/addEditReleaseNotes';
import {
  ALLOWED_TO_CUSTOMER_SERVICES,
  ALLOWED_TO_ADMIN,
  ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES,
  ALLOWED_TO_LEADS,
  ALLOWED_TO_LIVE_SCORING_ADMIN,
  ALLOWED_TO_AFCON_ADMINS,
} from './roles';
import WifiPackagesSubscriptionScreen from 'screens/wifiPackagesSubscriptionScreen';
import BranchFeatureTableScreen from '../../screens/branchFeaturesScreen';
import AddEditBranchFeatureScreen from '../../screens/branchFeaturesScreen/addEditBranchFeature';
import WaterfrontTransactionsManagement from 'screens/waterfrontTransactionsManagementScreen';
import FacilityGroups from "../../screens/FacilitiesGroupsScreen/facilitiesGroups";
import AddEditFacilityGroup from "../../screens/addEditFacilitiesGroupScreen/addEditFacilityGroup";
import DeliveryRegionsTableScreen from 'screens/deliveryRegionsScreen';
import AddEditDeliveryRegionScreen from 'screens/deliveryRegionsScreen/addEditDeliveryRegion';
import CardsDeliveryRequestsTableScreen from 'screens/cardsDeliveryRequestsScreen';
import AddEditNoAccess from "screens/addEditNoAccessWheelList/addEditNoAccess";
import noAccessWheelScreen from "../../screens/noAccessWheelScreen/noAccessWheelScreen";
import LeadsScreen from "../../screens/Leads";
import SportsList from 'screens/liveScoring/screens/sports/sportsList';
import TournamentsList from 'screens/liveScoring/screens/tournament/TournamentList';
import TeamList from 'screens/liveScoring/screens/teams/TeamList';
import MatchesList from 'screens/liveScoring/screens/matches/MatchList';
import EventsList from 'screens/liveScoring/screens/events/EventsList';
import AfconMatches from 'screens/afcon/matches/list';
import Predictions from 'screens/afcon/predictions/list';

export const Aux = (props: any) => props.children;

const NotFoundContent = () => <Typography variant="h5" component="h2"> Not Found </Typography>;

interface IProps {
  authStore: AuthStore;
}

@inject('authStore')
@observer
class Layout extends Component<IProps> {
  state = {
    navOpened: true,
  };

  handleNavButton = () => {
    this.setState({
      navOpened: !this.state.navOpened,
    });
  };

  async componentWillMount() {
    const {
      authStore,
    } = this.props;
    await authStore.getCurrentUser();
    let isEgypt = false;
    if (authStore.userData.countries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      isEgypt = true;
    }
    if (!isEgypt) {
      changeDefaultLanguage(languageCodes.english);
    } else {
      changeDefaultLanguage(languageCodes.arabic);
    }
  }

  userFallBackRoute = (isSports: boolean) => {
    if (isSports) {
      return '/academies';
    }
    return '/statistics';
  };

  userFallBackComponent = (isSports: boolean) => {
    if (isSports) {
      return Academies;
    }
    return Statistics;
  };

  render() {
    const {
      userData, isLoadingUserData,
    } = this.props.authStore;
    if (isLoadingUserData) {
      return (<Spinner />);
    }
    const {
      title,
    } = userData.role;

    const isKenyaAdmin = title === ROLES.KENYA_ADMIN;
    const isAdmin = title === ROLES.ADMIN;
    const isMarketing = title === ROLES.MARKETING;
    const isCustomerService = title === ROLES.CUSTOMER_SERVICE;
    const isSports = title === ROLES.SPORTS;
    const isWheel = title === ROLES.Wheel;
    const isOperations = title === ROLES.OPERATIONS;
    const isRating = title === ROLES.Rating;
    const isFinance = title === ROLES.FINANCE;
    const isPartnership = title === ROLES.PARTNERSHIP;
    const isCopywriter = title === ROLES.COPYWRITER;
    const isSuperAdmin = title === ROLES.SUPER_ADMIN || title === ROLES.DEV_ADMIN;
    const isDelivery = title === ROLES.Delivery;
    const isRestaurantAdmin = title === ROLES.RESTAUANT_ADMIN;


    const fallBackRoute = this.userFallBackRoute(isSports);
    const fallBackComponent = this.userFallBackComponent(isSports);
    return (
      <div className={styles.mainSection}>
        <Header onNavClicked={this.handleNavButton} />
        <div className={styles.secondarySection}>
          <Directives dIf={this.state.navOpened}>
            <div className={styles.navBar}>
              <NavBar />
            </div>
          </Directives>
          <div className={styles.mainContent}>
            <ScrollToTop {...{
            }}
            >
              <Switch>
                <AuthenticationRoute
                  path="/"
                  component={fallBackComponent}
                  hasPermission={false}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/home"
                  component={Home}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/home/new"
                  component={CreateHomeCards}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/home/:cardId"
                  component={CreateHomeCards}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/branches"
                  component={Branches}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/branches/new"
                  component={AddEditBranch}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/branches/:id/edit"
                  component={AddEditBranch}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news-categories"
                  component={NewsCategories}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news-categories/new"
                  component={AddEditNewsCategory}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news-categories/:id/edit"
                  component={AddEditNewsCategory}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/academies"
                  component={Academies}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/academies/new"
                  component={AddEditAcademy}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/academies/:id/edit"
                  component={AddEditAcademy}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news"
                  component={(props: any) => <News {...props} type="news" />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news/new"
                  component={(props: any) => <AddEditArticle {...props} type="news" />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/news/:id/edit"
                  component={(props: any) => <AddEditArticle {...props} type="news" />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/academies-announcements"
                  component={(props: any) => <News {...props} type="announcement" />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/academies-announcements/new"
                  component={(props: any) => <AddEditArticle {...props} type="announcement" />}
                  exact
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                />
                <AuthenticationRoute
                  path="/academies-announcements/:id/edit"
                  component={(props: any) => <AddEditArticle {...props} type="announcement" />}
                  exact
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isSports || isKenyaAdmin}
                />
                <AuthenticationRoute
                  path="/restaurants"
                  component={Restaurants}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/new"
                  component={AddEditRestaurant}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:id/edit"
                  component={AddEditRestaurant}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:id/bulk"
                  component={RestaurantMenuBulkUpload}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories"
                  component={RestaurantCategories}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories/new"
                  component={AddEditRestaurantCategory}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories/:categoryId/edit"
                  component={AddEditRestaurantCategory}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories/:categoryId/menus"
                  component={MenuManagement}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories/:categoryId/menus/new"
                  component={AddEditMenu}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/restaurants/:restaurantId/categories/:categoryId/menus/:menuId/edit"
                  component={AddEditMenu}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isRestaurantAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/banner-ads"
                  component={BannerAds}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/general-ads"
                  component={GeneralAds}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/general-ads/edit/:id"
                  component={(props: any) => <AddEditGeneralAd {...props} />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/general-ads/new"
                  component={(props: any) => <AddEditGeneralAd {...props} />}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/banner-ads/new"
                  component={AddEditAds}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                    path="/no-access-wheel/new"
                    component={AddEditNoAccess}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                    roleFallbackRoute={fallBackRoute}
                    fallbackComponent={fallBackComponent}
                    exact
                />
                <AuthenticationRoute
                    path="/no-access-wheel"
                    component={noAccessWheelScreen}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                    roleFallbackRoute={fallBackRoute}
                    fallbackComponent={fallBackComponent}
                    exact
                />
                <AuthenticationRoute
                  path="/banner-ads/:id/edit"
                  component={AddEditAds}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin || isSports}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/featured-articles"
                  component={FeaturedArticlesManagement}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/featured-articles/:featuredArticleId/edit"
                  component={AddEditFeaturedArticles}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/featured-articles/new"
                  component={AddEditFeaturedArticles}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-categories"
                  component={FacilitiesCategories}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facility-groups"
                  component={FacilityGroups}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gates"
                  component={Gates}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gates/new"
                  component={AddEditGate}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gates/:id/edit"
                  component={AddEditGate}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-categories/new"
                  component={AddEditFacilityCategory}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-group/new"
                  component={AddEditFacilityGroup}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-group/:id/edit"
                  component={AddEditFacilityGroup}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-categories/:id/edit"
                  component={AddEditFacilityCategory}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-areas"
                  component={FacilitiesArea}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations  || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-areas/new"
                  component={AddEditFacilityArea}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-areas/:id/edit"
                  component={AddEditFacilityArea}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations  || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-form"
                  component={FacilityForm}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-form/new"
                  component={AddEditFacilityForm}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations  || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/facilities-form/:id/edit"
                  component={AddEditFacilityForm}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isOperations  || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gallery"
                  component={Gallery}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gallery/new"
                  component={AddEditGalleryImage}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/gallery/:id/edit"
                  component={AddEditGalleryImage}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/staticTexts/:app"
                  component={StaticTexts}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isCopywriter}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/staticTexts/:app/:id/edit"
                  component={AddEditStaticText}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isCopywriter}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/staticTexts/:app/new"
                  component={AddEditStaticText}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isCopywriter}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/deglawy/featured"
                  component={DeglawyFeaturedScreen}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/deglawy/featured/new"
                  component={AddEditDeglawyFeatured}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/deglawy/featured/:id/edit"
                  component={AddEditDeglawyFeatured}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  path="/deglawy/trophies"
                  component={DeglawyTrophyScreen}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  exact
                />
                <AuthenticationRoute
                  component={DeglawyTrophyScreen}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/trophies"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeglawyTrophy}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/trophies/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeglawyTrophy}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/trophies/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={DeglawyContents}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isCopywriter}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/contents"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeglawyContent}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing || isCopywriter}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/contents/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={DeglawyPortalContents}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/portal/contents"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeglawyPortalContent}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/portal/contents/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={FeaturedOffer}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/featuredOffer"
                  exact
                />
                <AuthenticationRoute
                  component={addEditFeaturedOffer}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/featuredOffer/new"
                  exact
                />
                <AuthenticationRoute
                  component={addEditFeaturedOffer}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/deglawy/featuredOffer/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={Notifications}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/notifications"
                  exact
                />
                <AuthenticationRoute
                  component={AddNotification}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/notifications/new"
                  exact
                />
                <AuthenticationRoute
                  component={Facilities}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditFacility}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing || isOperations}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditFacility}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isMarketing || isOperations}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={RatingFacilitiesBranchesList}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/reports/branches"
                  exact
                />
                <AuthenticationRoute
                  component={FacilitiesBranchStatistics}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/reports/branches/:id/statistics"
                  exact
                />
                <AuthenticationRoute
                  component={FacilitiesAreaStatistics}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/reports/branches/:branchId/areas/:areaId/statistics"
                  exact
                />
                <AuthenticationRoute
                  component={RatingFacilitiesAreasList}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/reports/branches/:branchId/areas"
                  exact
                />
                <AuthenticationRoute
                  component={RatingFacilitiesReport}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/reports/branches/:branchId/areas/:areaId"
                  exact
                />
                <AuthenticationRoute
                  component={FacilityStatistics}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/:facilityId/statistics"
                  exact
                />
                <AuthenticationRoute
                  component={FacilityResponseReports}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isOperations ||isRating}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facilities/rating/reports/:facilityId"
                  exact
                />
                <AuthenticationRoute
                  component={addEditSettings}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/settings/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={Settings}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/settings"
                  exact
                />
                <AuthenticationRoute
                  component={Statistics}
                  hasPermission={isSuperAdmin || isAdmin || isCustomerService}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/statistics"
                  exact
                />
                <AuthenticationRoute
                  component={CustomerServiceWorkingHours}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin || isCustomerService}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/settings/cs-working-hours"
                  exact
                />
                <AuthenticationRoute
                  component={UsersManagement}
                  hasPermission={isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditAdminUsers}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users/new"
                  exact
                />
                <AuthenticationRoute
                  component={ChangePassword}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users/:id/changePassword"
                  exact
                />
                <AuthenticationRoute
                  component={UserRenewalsScreen}
                  hasPermission={isSuperAdmin || isAdmin || isCustomerService}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users/:userId/renewals"
                  exact
                />
                <AuthenticationRoute
                  component={calenderSeprator}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/calender/separator"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditCalenderSeprator}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/calender/separator/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditCalenderSeprator}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/calender/separator/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={eventCategory}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/category"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEventCategory}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/category/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEventCategory}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/category/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={event}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEvent}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEvent}
                  hasPermission={isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/events/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={TransactionsManagement}
                  hasPermission={ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/transactions/renewals"
                  exact
                />
                <AuthenticationRoute
                  component={TransactionsDetails}
                  hasPermission={ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/transactions/renewals/:id"
                  exact
                />
                <AuthenticationRoute
                  component={WaterfrontTransactionsManagement}
                  hasPermission={ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/transactions/waterfront"
                  exact
                />
                <AuthenticationRoute
                  component={TransactionsDetails}
                  hasPermission={ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/transactions/waterfront/:id"
                  exact
                />
                <AuthenticationRoute
                  component={OffersScreen}
                  hasPermission={isPartnership || isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/offers"
                  exact
                />
                <AuthenticationRoute
                  component={addEditOffer}
                  hasPermission={isPartnership || isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/offers/new"
                  exact
                />
                <AuthenticationRoute
                  component={addEditOffer}
                  hasPermission={isPartnership || isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/offers/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={WifiPackagesScreen}
                  hasPermission={isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wifi-packages"
                  exact
                />
                <AuthenticationRoute
                  component={WifiPackagesSubscriptionScreen}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wifi-packages/subscription"
                  exact
                />
                <AuthenticationRoute
                  component={WifiPackagesUserSubscribeDetails}
                  hasPermission={isCustomerService || isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users/:userId/wifi-packages"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditWifiPackage}
                  hasPermission={isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wifi-packages/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditWifiPackage}
                  hasPermission={isSuperAdmin || isAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wifi-packages/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={CustomScreens}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/custom-screens"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditCustomScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/custom-screens/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditCustomScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/custom-screens/:customScreenKeyParam/edit"
                  exact
                />
                <AuthenticationRoute
                  component={SurveysScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/survey"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditSurveyScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/survey/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditSurveyScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/survey/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={WheelEventsGroupsScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events-groups"
                  exact
                />
                <AuthenticationRoute
                  component={WheelEventsScreen}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEventScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditEventScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/new"
                  exact
                />
                <AuthenticationRoute
                  component={WheelPrizesScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/:eventId/prizes"
                  exact
                />
                <AuthenticationRoute
                  component={WheelEventWinnersScreen}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/:eventId/winners"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditPrizeScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/:eventId/prizes/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditPrizeScreen}
                  hasPermission={isSuperAdmin || isAdmin || isKenyaAdmin}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/wheel-fortune/events/:eventId/prizes/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={MobileUserRegistration}
                  hasPermission={isSuperAdmin || isCustomerService}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/super-managment/registration"
                  exact
                />
                <AuthenticationRoute
                  component={UserDetails}
                  hasPermission={ALLOWED_TO_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/users/:userId"
                  exact
                />
                <AuthenticationRoute
                  component={FacebookInfo}
                  hasPermission={isSuperAdmin || isAdmin || isMarketing}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/facebook-info"
                  exact
                />
                <AuthenticationRoute
                  component={ReleasesNotesTableScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/release-notes"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditReleaseNotesScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/release-notes/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditReleaseNotesScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/release-notes/new"
                  exact
                />
                <AuthenticationRoute
                  component={BranchFeatureTableScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/branch-features"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditBranchFeatureScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/branch-features/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditBranchFeatureScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/branch-features/new"
                  exact
                />
                <AuthenticationRoute
                  component={DeliveryRegionsTableScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/delivery-regions"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeliveryRegionScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/delivery-regions/:id/edit"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditDeliveryRegionScreen}
                  hasPermission={ALLOWED_TO_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/delivery-regions/new"
                  exact
                />
                <AuthenticationRoute
                  component={CardsDeliveryRequestsTableScreen}
                  hasPermission={ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/cards-delivery"
                  exact
                />
                <AuthenticationRoute
                  component={LeadsScreen}
                  hasPermission={ALLOWED_TO_LEADS(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/leads"
                  exact
                />
                <AuthenticationRoute
                  component={SportsList}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/sports"
                  exact
                />
                <AuthenticationRoute
                  component={TournamentsList}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/tournaments"
                  exact
                />
                <AuthenticationRoute
                  component={TeamList}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/teams"
                  exact
                />
                <AuthenticationRoute
                  component={MatchesList}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/matches"
                  exact
                />
                <AuthenticationRoute
                  component={EventsList}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/matches/:id/events"
                  exact
                />
                {/* <AuthenticationRoute
                  component={AddEditSportScreen}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/sports/new"
                  exact
                /> */}
                {/* <AuthenticationRoute
                  component={AddEditSportScreen}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/sports/:id/edit"
                  exact
                /> */}

                {/* 
                <AuthenticationRoute
                  component={AddEditTournamentScreen}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/tournaments/new"
                  exact
                />
                <AuthenticationRoute
                  component={AddEditTournamentScreen}
                  hasPermission={ALLOWED_TO_LIVE_SCORING_ADMIN(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/tournaments/:id/edit"
                  exact
                /> */}
                <AuthenticationRoute
                  component={AfconMatches}
                  hasPermission={ALLOWED_TO_AFCON_ADMINS(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/afcon/matches"
                  exact
                />
                <AuthenticationRoute
                  component={Predictions}
                  hasPermission={ALLOWED_TO_AFCON_ADMINS(title)}
                  roleFallbackRoute={fallBackRoute}
                  fallbackComponent={fallBackComponent}
                  path="/afcon/matches/:matchId/predictions"
                  exact
                />

                <Route render={NotFoundContent} />
              </Switch>
            </ScrollToTop>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;
